module.exports = __webpack_public_path__ + "img/signature-2.5724e42a.jpg";